import { Helmet } from "react-helmet";
import {
  CAPT_BHUWANESHWAR_SINGH,
  CAPT_BHUWANESHWAR_SINGH_TEXT_1,
  CAPT_BHUWANESHWAR_SINGH_TEXT_2,
  CAPT_RAKESH_JOHARI,
  CAPT_RAKESH_JOHARI_TEXT,
  KEY_PERSONNEL,
  KEY_PERSONNEL_TEXT,
  MASTER_MARINER,
  MASTER_MARINER_CHARTERING_OPERATIONS_SPECIALIST,
  MOT_CHIEF_ENGINEER_TECHNICAL_HEAD,
  MR_RAKESH_TALWAR,
  MR_RAKESH_TALWAR_TEXT,
} from "../../constants/translations";
import PageHeader from "../../hybrids/PageHeader/PageHeader";
import PersonnelBoxes from "./PersonnelBoxes";

const KeyPersonnel = () => {
  const personnel = [
    {
      name: CAPT_BHUWANESHWAR_SINGH,
      position: MASTER_MARINER_CHARTERING_OPERATIONS_SPECIALIST,
      text: [CAPT_BHUWANESHWAR_SINGH_TEXT_1, CAPT_BHUWANESHWAR_SINGH_TEXT_2],
    },
    {
      name: CAPT_RAKESH_JOHARI,
      position: MASTER_MARINER,
      text: [CAPT_RAKESH_JOHARI_TEXT],
    },
    {
      name: MR_RAKESH_TALWAR,
      position: MOT_CHIEF_ENGINEER_TECHNICAL_HEAD,
      text: [MR_RAKESH_TALWAR_TEXT],
    },
  ];
  return (
    <>
      <Helmet>
        <title>{KEY_PERSONNEL}</title>
      </Helmet>
      <div className="key-personnel-page-wrapper">
        <PageHeader
          customClassName="key-personnel-header"
          text={KEY_PERSONNEL_TEXT}
          title={KEY_PERSONNEL}
        />
        <PersonnelBoxes personnel={personnel} />
      </div>
    </>
  );
};

export default KeyPersonnel;
